// Stripe product configuration
export const products = [
  {
    id: 'prod_SaxSyT5MADU3Lg',
    name: 'Starter',
    description: 'Perfect for small teams beginning their wellness journey',
    priceId: 'price_1RflXxGaY644PMYjDoziNa1x',
    price: 8,
    interval: 'month',
    currency: 'USD',
    features: [
      'Weekly wellness check-ins',
      'Basic emotional insights',
      'Team mood dashboard',
      'Email support',
      'Privacy protection'
    ],
    mode: 'subscription'
  },
  {
    id: 'prod_SaxT4LOPhFIjq1',
    name: 'Professional',
    description: 'Advanced features for growing organizations committed to wellness',
    priceId: 'price_1RflYgGaY644PMYjkadqu50B',
    price: 16,
    interval: 'month',
    currency: 'USD',
    features: [
      'Everything in Starter',
      'Voice & text AI analysis',
      'Predictive wellness insights',
      'Custom care pathways',
      'Advanced team analytics',
      'Priority support'
    ],
    mode: 'subscription'
  }
];

// Get product by ID
export const getProductById = (id: string) => {
  return products.find(product => product.id === id);
};

// Get product by price ID
export const getProductByPriceId = (priceId: string) => {
  return products.find(product => product.priceId === priceId);
};